/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalSuiteObject,
  EvalSuiteObject$inboundSchema,
  EvalSuiteObject$Outbound,
  EvalSuiteObject$outboundSchema,
} from "./evalsuiteobject.js";

export type EvalSuiteList = {
  object: "list";
  data: Array<EvalSuiteObject>;
  firstId?: string | undefined;
  lastId?: string | undefined;
  hasMore: boolean;
};

/** @internal */
export const EvalSuiteList$inboundSchema: z.ZodType<
  EvalSuiteList,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(EvalSuiteObject$inboundSchema),
  first_id: z.string().optional(),
  last_id: z.string().optional(),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type EvalSuiteList$Outbound = {
  object: "list";
  data: Array<EvalSuiteObject$Outbound>;
  first_id?: string | undefined;
  last_id?: string | undefined;
  has_more: boolean;
};

/** @internal */
export const EvalSuiteList$outboundSchema: z.ZodType<
  EvalSuiteList$Outbound,
  z.ZodTypeDef,
  EvalSuiteList
> = z.object({
  object: z.literal("list"),
  data: z.array(EvalSuiteObject$outboundSchema),
  firstId: z.string().optional(),
  lastId: z.string().optional(),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function evalSuiteListToJSON(evalSuiteList: EvalSuiteList): string {
  return JSON.stringify(EvalSuiteList$outboundSchema.parse(evalSuiteList));
}
export function evalSuiteListFromJSON(
  jsonString: string,
): SafeParseResult<EvalSuiteList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalSuiteList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalSuiteList' from JSON`,
  );
}
